import {
  type GenerateStyle,
  type FullToken,
  genComponentStyleHook,
} from "antd/es/theme/internal";
import { selectPrefixCls } from "@/base/components/select/Select.component";
import { THEME_PREFIX, ICON_PREFIX } from "@/base/constant";

const genStyle: GenerateStyle<FullToken<"Select">> = (token: any) => {
  const {
    colorIcon,
    colorTextDisabled,
    borderRadius,
    controlHeight,
    controlHeightLG,
    controlHeightSM,
    optionFontSize,
    colorText,
  } = token;
  return {
    [`.${THEME_PREFIX}`]: {
      [`&.${selectPrefixCls}`]: {
        minHeight: controlHeight,

        [`&.${selectPrefixCls}-lg`]: {
          minHeight: controlHeightLG,
        },

        [`&.${selectPrefixCls}-sm`]: {
          minHeight: controlHeightSM,
          [`.${selectPrefixCls}-selector`]: {
            borderRadius: `${borderRadius / 2}px`,
          },
        },

        [`&:not(.${selectPrefixCls}-sm)`]: {
          [`.${selectPrefixCls}-selector`]: {
            borderRadius: `${borderRadius}px`,
          },
        },

        [`.${selectPrefixCls}-arrow`]: {
          marginTop: `-6px`,
          color: `${colorIcon}`,
          pointerEvents: "none !important" as any,

          [`.${ICON_PREFIX}`]: {
            pointerEvents: "none !important" as any,
          },
        },
        [`&.${selectPrefixCls}-disabled`]: {
          [`.${selectPrefixCls}-arrow`]: {
            color: `${colorTextDisabled}`,
          },
        },
      },
    },

    [`.${selectPrefixCls}-item-empty`]: {
      color: `${colorText} !important`,
      fontSize: `${optionFontSize} !important`,
    },
  };
};

export const useSelectStyle = genComponentStyleHook(
  ["Select", "cso"],
  (token) => {
    return [genStyle(token)];
  },
);
